import * as React from 'react'
import { Container } from 'react-bootstrap';


const ColoredLine = () => {

    return (

        <Container>

            <hr
                style={{
                    height: 1
                }}
            />

        </Container>

    )

}

export default ColoredLine